import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-opening-details',
  templateUrl: './admin-opening-details.component.html',
  styleUrls: ['./admin-opening-details.component.css']
})
export class AdminOpeningDetailsComponent implements OnInit {

  errMessage = "";
  successMessage = "";
  routeID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  openings = [];
  users = [];
  form: FormGroup;
  messageErr;
  selectedCategories = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {
     }

  opening;

  categories = [];

  ngOnInit(): void {
    this.fetchDetails();
    
  }

  fetchDetails() {

    this.http.get(environment.ADMIN_OPENING_DETAILS + '/' +this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.opening = res.message;
          console.log(this.opening)

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })


  }

  fetchCategories() {
    this.http.get(environment.ADMIN_PARAMS + '/opening-categories', this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          var msg = res.message['opening-categories'];
          var clear = [];
          for (var i = 0; i < msg.length; i++) {
            console.log(msg[i])
            if(msg[i]['hook'] == ""){
              clear.push(msg[i])
            }
          }
          this.categories = clear;
          console.log(this.categories)

          if(this.opening.categories){
            for (let i = 0; i < this.categories.length; i++) {
              const elm = this.categories[i];

              elm['selected'] = false;
              if(this.opening.categories.includes(elm.id)){
                elm['selected'] = true;
                break;
              }
              
            }
          }
          else{
            this.selectedCategories = [];
          }


        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  addToCategories(id){
    //MArk as selected
    for (let i = 0; i < this.categories.length; i++) {
      const elm = this.categories[i];
      if(elm.id == id){
        elm['selected'] = true;
        break;
      }
      
    }

  }

  removeFromCategories(id){
    //MArk as selected
    for (let i = 0; i < this.categories.length; i++) {
      const elm = this.categories[i];
      if(elm.id == id){
        elm['selected'] = false;
        break;
      }
      
    }

  }

  saveCatUpdate(){
      var selected = [];
      for (let i = 0; i < this.categories.length; i++) {
        const elm = this.categories[i];
        if(elm['selected']){
          console.log(elm)
          selected.push(elm.id)
        }
        
      }

      var data = {
        categories: selected
      }

      this.http.put(environment.ADMIN_OPENING_CATEGORIES + '/' +this.routeID, data, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            alert('Kategoriat päivitetty');
            
  
          }
          else {
            console.log('ei ole kyseistä käyttäjää')
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })

  }

}
